export default __webpack_public_path__ + "static/media/57t.07b46edc.jpg";